import type { ManagerProfile, UserResponse } from "@sidegigllc/api/client";
import React from "react";
import type { AnalyticsUserTraits } from "utils/analytics";

interface IAuthContextData {
  user: UserResponse;
  managerProfile?: ManagerProfile;
  analyticsUser?: AnalyticsUserTraits;
  hasLocations: boolean;

  signUpRequired: boolean;
  tosAccepted: boolean;
  locationRequired: boolean;
  linkableAccountsStatus: "idle" | "loading" | "linking-required" | "success" | "error";
}

export interface IAuthContext extends IAuthContextData {
  logout: () => Promise<void>;
  refreshUser: () => Promise<{ user: UserResponse; managerProfile: ManagerProfile } | undefined> | null;
}

export const AuthContext = React.createContext<IAuthContext>({} as IAuthContext);
